var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"btnTop",staticClass:"btn-top",class:{ on: _vm.isOn },attrs:{"type":"button"},on:{"click":function($event){return _vm.goTop()}}},[_vm._v(" TOP ")])
}
var staticRenderFns = []

export { render, staticRenderFns }